__turbopack_context__.v({
  "buttonContainer": "_8N6FlG_buttonContainer",
  "container": "_8N6FlG_container",
  "contentWrapper": "_8N6FlG_contentWrapper",
  "fullWidthButton": "_8N6FlG_fullWidthButton",
  "headline": "_8N6FlG_headline",
  "subtitle": "_8N6FlG_subtitle",
  "textContainer": "_8N6FlG_textContainer",
});
